"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;

var _BaseText = require("./BaseText");

var _colors = _interopRequireDefault(require("../colors"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _generateTextComponent = require("./generateTextComponent");

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Title = function Title(_ref) {
  var size = _ref.size,
      props = _objectWithoutProperties(_ref, ["size"]);

  return _react.default.createElement(_BaseText.Base, _extends({
    styles: size
  }, props));
};

exports.Title = Title;
Title.Sizes = {
  ExtraLarge: _objectSpread({}, _BaseText.Base.Styles.Bold40, {
    size: 64
  }),
  Large: _BaseText.Base.Styles.Bold40,
  Medium: _BaseText.Base.Styles.Bold32,
  Small: _BaseText.Base.Styles.Bold24,
  ExtraSmall: _BaseText.Base.Styles.Bold18
};
Title.Colors = {
  Black: _colors.default.TextPrimary,
  Dark: _colors.default.TextPrimary,
  Light: _colors.default.SystemWhite,
  Body: _colors.default.TextSecondary,
  Tertiary: _colors.default.TextTertiary,
  Red: _colors.default.SystemRed60
};
Title.propTypes = _objectSpread({}, _generateTextComponent.defaultTextProps, {
  size: _propTypes.default.oneOf(Object.values(Title.Sizes)),
  color: _propTypes.default.oneOf((0, _utilities.getAllPropCasesForColors)(Object.values(Title.Colors)))
});
Title.defaultProps = {
  size: Title.Sizes.Medium,
  color: Title.Colors.Black
};